import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { mvpApiGetAllUserMetrics } from "@labeling-tools/api/user-insights/generated/sdk.gen";
import type { UserMetricsRowSchema } from "@labeling-tools/api/user-insights/generated/types.gen";
import type { MetricsPeriod } from "@/utils/userInsights";

export type LabelerMetricsRow = UserMetricsRowSchema;

// One request for every viewable labeler's metrics (GET /users/metrics),
// replacing the old per-user fan-out.
export function useAdminLabelerMetrics(
  taskType: string,
  period: MetricsPeriod,
) {
  return useQuery<LabelerMetricsRow[]>({
    queryKey: ["user-insights", "users-metrics", taskType, period],
    queryFn: async () => {
      const res = await mvpApiGetAllUserMetrics({
        query: { task_type: taskType, period },
      });
      if (res.error)
        throw new Error(
          `Failed to load labeler metrics: ${JSON.stringify(res.error)}`,
        );
      return res.data?.users ?? [];
    },
    staleTime: 5 * 60 * 1000,
    // Keep the table on screen while a new period loads.
    placeholderData: keepPreviousData,
  });
}
